/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GeneratedReportCriteria} from '../models/GeneratedReportCriteria';
import type {ReportType} from '../models/ReportType';
import type {UserUsageCriteria} from '../models/UserUsageCriteria';

export interface DownloadReportById$Request {
    reportId: string;
}

export interface DownloadReportById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const downloadReportByIdRequest = createAction<PayloadData<void, DownloadReportById$Request>>('USAGE_REPORTS_V2__DOWNLOAD_REPORT_BY_ID__REQUEST');
export const downloadReportByIdSuccess = createAction<PayloadData<any, DownloadReportById$Request>>('USAGE_REPORTS_V2__DOWNLOAD_REPORT_BY_ID__SUCCESS');
export const downloadReportByIdFailure = createAction<PayloadData<Error, DownloadReportById$Request, true>>('USAGE_REPORTS_V2__DOWNLOAD_REPORT_BY_ID__FAILURE');

export const downloadReportByIdActions = [
    downloadReportByIdRequest,
    downloadReportByIdSuccess,
    downloadReportByIdFailure
] as const;

/**
 * @param {string} meta.reportId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const downloadReportById = (meta: DownloadReportById$Request, config?: DownloadReportById$Config) => {
    return {
        DOWNLOAD_FILE: {
            types: downloadReportByIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/reports/${meta.reportId}/download`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/octet-stream, application/json',
            }
        },
        ...meta
    }
};

export interface GetCriteriaByReportId$Request {
    reportId: string;
}

export interface GetCriteriaByReportId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCriteriaByReportIdRequest = createAction<PayloadData<void, GetCriteriaByReportId$Request>>('USAGE_REPORTS_V2__GET_CRITERIA_BY_REPORT_ID__REQUEST');
export const getCriteriaByReportIdSuccess = createAction<PayloadData<GeneratedReportCriteria, GetCriteriaByReportId$Request>>('USAGE_REPORTS_V2__GET_CRITERIA_BY_REPORT_ID__SUCCESS');
export const getCriteriaByReportIdFailure = createAction<PayloadData<Error, GetCriteriaByReportId$Request, true>>('USAGE_REPORTS_V2__GET_CRITERIA_BY_REPORT_ID__FAILURE');

export const getCriteriaByReportIdActions = [
    getCriteriaByReportIdRequest,
    getCriteriaByReportIdSuccess,
    getCriteriaByReportIdFailure
] as const;

/**
 * @param {string} meta.reportId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCriteriaByReportId = (meta: GetCriteriaByReportId$Request, config?: GetCriteriaByReportId$Config) => {
    return {
        CALL_API: {
            types: getCriteriaByReportIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/reports/criteria/${meta.reportId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsageReportAsync$Request {
    reportType: ReportType;
    userUsageCriteria: UserUsageCriteria;
}

export interface GetUsageReportAsync$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsageReportAsyncRequest = createAction<PayloadData<void, GetUsageReportAsync$Request>>('USAGE_REPORTS_V2__GET_USAGE_REPORT_ASYNC__REQUEST');
export const getUsageReportAsyncSuccess = createAction<PayloadData<void, GetUsageReportAsync$Request>>('USAGE_REPORTS_V2__GET_USAGE_REPORT_ASYNC__SUCCESS');
export const getUsageReportAsyncFailure = createAction<PayloadData<Error, GetUsageReportAsync$Request, true>>('USAGE_REPORTS_V2__GET_USAGE_REPORT_ASYNC__FAILURE');

export const getUsageReportAsyncActions = [
    getUsageReportAsyncRequest,
    getUsageReportAsyncSuccess,
    getUsageReportAsyncFailure
] as const;

/**
 * @param {ReportType} meta.reportType
 * @param {UserUsageCriteria} meta.userUsageCriteria
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsageReportAsync = (meta: GetUsageReportAsync$Request, config?: GetUsageReportAsync$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reportType: meta.reportType,
    };
    return {
        CALL_API: {
            types: getUsageReportAsyncActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/reports/asynchronously/user-usage`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.userUsageCriteria,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsageReportSync$Request {
    reportType: ReportType;
    userUsageCriteria: UserUsageCriteria;
}

export interface GetUsageReportSync$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsageReportSyncRequest = createAction<PayloadData<void, GetUsageReportSync$Request>>('USAGE_REPORTS_V2__GET_USAGE_REPORT_SYNC__REQUEST');
export const getUsageReportSyncSuccess = createAction<PayloadData<any, GetUsageReportSync$Request>>('USAGE_REPORTS_V2__GET_USAGE_REPORT_SYNC__SUCCESS');
export const getUsageReportSyncFailure = createAction<PayloadData<Error, GetUsageReportSync$Request, true>>('USAGE_REPORTS_V2__GET_USAGE_REPORT_SYNC__FAILURE');

export const getUsageReportSyncActions = [
    getUsageReportSyncRequest,
    getUsageReportSyncSuccess,
    getUsageReportSyncFailure
] as const;

/**
 * @param {ReportType} meta.reportType
 * @param {UserUsageCriteria} meta.userUsageCriteria
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsageReportSync = (meta: GetUsageReportSync$Request, config?: GetUsageReportSync$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reportType: meta.reportType,
    };
    return {
        DOWNLOAD_FILE: {
            types: getUsageReportSyncActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/reports/synchronously/user-usage`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.userUsageCriteria,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/octet-stream, application/json',
            }
        },
        ...meta
    }
};

